import React from 'react';
import { Modal, Switch, message, notification } from 'antd';
import { cleanRpcError } from 'client/modules/common/utils/rpcError';
import useSetTeamAttribute from '../../hooks/useSetTeamAttribute';
import { parseBooleanAttribute } from '../../utils/mcpAttributes';

type Props = {
  idTeam: number;
  attribute: string;
  label: string;
  type: string;
  value: string | null;
  refetch: () => void;
  disabled?: boolean;
};

const SUBMIT_ERROR_KEY = 'mcp-hard-cap-error';

const McpHardCapSwitch = ({
  idTeam,
  attribute,
  label,
  type,
  value,
  refetch,
  disabled,
}: Props) => {
  const isEnabled = parseBooleanAttribute(value);

  const { onSubmit, isLoading } = useSetTeamAttribute(idTeam);

  const handleConfirm = async () => {
    try {
      await onSubmit({ attribute, type, value: String(!isEnabled) });
      message.success(
        `Success! ${label} has been ${isEnabled ? 'disabled' : 'enabled'}.`
      );
      refetch();
    } catch (error) {
      notification.error({
        key: SUBMIT_ERROR_KEY,
        message: `Failed to update ${label}`,
        description: cleanRpcError(error),
        placement: 'top',
        duration: 10,
      });
    }
  };

  const handleChange = () => {
    Modal.confirm({
      title: `Change ${label}`,
      content: `Are you sure you want to ${
        isEnabled ? 'disable' : 'enable'
      } this setting?`,
      onOk: handleConfirm,
    });
  };

  return (
    <Switch
      checked={isEnabled}
      onChange={handleChange}
      disabled={disabled}
      loading={isLoading}
      aria-label={label}
    />
  );
};

export default McpHardCapSwitch;
